<template>
  <div id="rateTableNew">
    <div v-show="isLoaded" :class="{'consumer-style': isConsumer}">
      <rate-table-filter
        v-if="showFilters"
        :filter="filter"
        :isWp="isConsumer"
        :showDepositAmountAndEstEarning="showDepositAmountAndEstEarning"
        :showRegionFilter="showRegionFilter"
        :showAvailabilityFilter="showAvailabilityFilter"
        :showInstitutionFilter="showInstitutionFilter"
      ></rate-table-filter>
      <rate-table v-show="hasData"
        :filter="filter"
        v-on:data-loaded="rateTableDataLoaded"
        v-on:ratetable-response="rateTableResponseCalled"
        :isWp="isConsumer"
        :zoneKeys="zoneKeys"
        :labelCTAButton="labelCtaButton"
        :CTAButtonColor="ctaButtonColor"
        :showFilters="showFilters"
        :showDepositAmountAndEstEarning="showDepositAmountAndEstEarning"
        :showRegionFilter="showRegionFilter"
        :showResultsTable="showResultsTableComputed"
        :showAdCopy="showAdCopy"
        :frictionLevel="frictionModal"
      >
          <template v-slot:rate-table-title>
            <span v-if="rateTableTitleText">
              {{rateTableTitleText}}
            </span>
            <slot name="rate-table-title" v-else>
              <animated-number :number="totalAccounts" class="resultsHeader"></animated-number>
              {{totalAccounts > 1 ? 'Results' : 'Result'}}
            </slot>
          </template>
        
      </rate-table>
    </div>
    <div v-show="!isLoaded">
      <rate-table-loader
        :showFilters="showFilters"></rate-table-loader>
    </div>
  </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import RateTableFilter from "./rate-table-filter.vue";
import RateTable from "./rate-table.vue";
import RateTableLoader from "./rate-table-ghost-loader.vue";
import animatedNumber from "../../components/animated-number.vue";
import { get as getCookie } from "es-cookie";
import "./scss/rate-table.scss";

export default defineComponent({
  components: {
    "rate-table-filter": RateTableFilter,
    "rate-table": RateTable,
    "rate-table-loader": RateTableLoader,
    "animated-number": animatedNumber
  },
  props:{
    isConsumer:{
      default: false
    },
    depositAmountVal: {
      default: 25000
    },
    zoneKeys:{
      default: ''
    },
    labelCtaButton:{
      default: ""
    },
    ctaButtonColor: {
      default:'#F90'
    },
    showFilters:{
      default: true
    },
    showDepositAmountAndEstEarning:{
      default: true
    },
    showRegionFilter: {
      default:true
    },
    showAvailabilityFilter: {
      default: true
    },
    availabilityFilterVal: {
      default:"branchAndOnline"
    },
    showInstitutionFilter: {
      default: true
    },
    institutionFilterVal: {
      default:"bankAndCredit"
    },
    showResultsTable: {
      default: undefined
    },
    showAdCopy: {
      default: false
    },
    frictionModal: {
      default: "none"
    },
    title: {
      default: ""
    }
  },
  data: function() {
    return {
      filter: {
        depositAmount: this.depositAmountVal,
        region: "",
        state: null,
        dma: 0,
        sort: "default",
        availability: this.availabilityFilterVal,
        institutionType: this.institutionFilterVal,
        selectedUnionOptions: []
      },
      isLoaded: false,
      hasData: false,
      totalAccounts: 0
    };
  },
  computed:{
    showResultsTableComputed() : Boolean{
      if(this.showResultsTable){
        return true;
      }
      return this.showResultsTable == undefined && !this.isConsumer; 
    },
    rateTableTitleText() : string {
      return this.title.replace("[counter]", this.totalAccounts.toString());
    }
  },
  methods: {
    rateTableDataLoaded: function(val: any) {
      this.isLoaded = val;
    },
    rateTableResponseCalled(rateTableResp : RateTable.Response) {
        this.hasData = rateTableResp.topZone.some(x => x.placements.length > 0) || rateTableResp.bottomZone.placements.length > 0 || rateTableResp.bottomZone.accounts.length > 0;
        let placementsCount = 0;
        if(rateTableResp.topZone.length > 0){
          placementsCount = rateTableResp.topZone.map(x => x.totalAccounts).reduce((accumulate, currentValue) => { return accumulate + currentValue });
        }
        this.totalAccounts = placementsCount + rateTableResp.bottomZone.totalAccounts;
        this.$emit("ratetable-response", rateTableResp);
    }
  },
  
});
</script>
<style lang="scss">
html {
    overflow-x: initial;
    overflow-y: initial;
  }
.pull-right {
  float: right;
}
#rateTableNew {
  font-family: 'Titillium Web', sans-serif;
  font-size: 13px;
  line-height: normal;
  a {
    color: #4699bb;
    text-decoration: none;
    border:initial;
    &[href]:hover{
      text-decoration: underline;
    }
  }
  p{
    font-size: 16px;
    color: #4a4a4a;
    margin-bottom: 10px;
    line-height: 25px;
  }
  input[type="checkbox"] {
    line-height: normal;
    margin: 4px 5px 0 0;
  }  
}
</style>
<style lang="scss">
.consumer-style {
  @media (max-width: 575px) {
    .resultsHeader {
      display: none;
    }
  }
}
</style>